import useBellaCookies from '../useBellaCookies';

export const PROMO_BAR_BANNER_DISMISSED = 'promoHeaderBannerVisited';

const usePromoBarDismissed = (): [boolean, (expiration: number) => void] => {
    const [status, setStatus] = useBellaCookies(PROMO_BAR_BANNER_DISMISSED, true);
    const promoBarDismissedInLastThirtyDays = !!status;

    const setHasBeenDismissed = (expiration: number) => {
        setStatus(1, expiration);
    };

    return [promoBarDismissedInLastThirtyDays, setHasBeenDismissed];
};

export default usePromoBarDismissed;
